var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
export class AwardingOrganisationsService extends BaseRemoteService {
    getAll(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
    get(id) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const encodedParam = encodeURIComponent(id);
            const url = `${this.apiRoot}/organisations/by-rn/${encodedParam}`;
            const data = yield _super.getRequest.call(this, url);
            return Object.assign(Object.assign({}, data), { id: data.recognitionNumber });
        });
    }
}
